const LangString = require('@/lib/Lang/LangString');
const { langFilter } = require('@/vue/filters/langFilter');

/**
 * @param {OptionSet[]} optionSets
 * @param {Object<number, number[]>} selections
 *
 * @returns {string[]}
 */
const validateItemOptionSelections = (optionSets, selections) => {
    const errors = [];

    for (const optionSet of optionSets) {
        const optionSetErrors = validateOptionSet(
            optionSet,
            selections[optionSet.ID] || []
        );
        errors.push(...optionSetErrors);
    }

    return errors;
};

const validateOptionSet = (optionSet, selections) => {
    const errors = [];

    // Validate min/max qty.
    if (
        (optionSet.minOptions && selections.length < optionSet.minOptions)
        || (optionSet.maxOptions && selections.length > optionSet.maxOptions)
    ) {
        errors.push(
            langFilter(getHelpTextForOptionSet(optionSet, selections))
            + ' '
            + langFilter('ITEM_OPTIONS.CHOOSE_FOR', { optionName: optionSet.name })
            + '.'
        );
    }

    return errors;
};

const getHelpTextForOptionSet = (optionSet) => {
    const min = optionSet.minOptions;
    const max = optionSet.maxOptions;

    if (min && max && min === max) {
        if (max === 1) {
            return new LangString('ITEM_OPTIONS.CHOOSE_EXACTLY_ONE');
        }
        return new LangString('ITEM_OPTIONS.CHOOSE_EXACTLY', { min, max });
    } else if (min && max) {
        return new LangString('ITEM_OPTIONS.CHOOSE_BETWEEN', { min, max });
    } else if (min) {
        if (min === 1) {
            return new LangString('ITEM_OPTIONS.CHOOSE_AT_LEAST_ONE');
        }
        return new LangString('ITEM_OPTIONS.CHOOSE_AT_LEAST', { min });
    } else if (max) {
        if (max === 1) {
            return new LangString('ITEM_OPTIONS.CHOOSE_UP_TO_ONE');
        }
        return new LangString('ITEM_OPTIONS.CHOOSE_UP_TO', { max });
    }

    return '';
};

module.exports = {
    validateItemOptionSelections,
    getHelpTextForOptionSet,
};
